"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModImageType = void 0;
var ModImageType;
(function (ModImageType) {
    ModImageType["Storefront"] = "storefront";
    ModImageType["Carousel"] = "carousel";
    ModImageType["AboutImg"] = "aboutImg";
    ModImageType["Thumbnail"] = "Thumbnail";
    ModImageType["Featured"] = "Featured";
})(ModImageType = exports.ModImageType || (exports.ModImageType = {}));
//# sourceMappingURL=image.js.map